
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#fff","viewBox":"-0.855 -0.855 24 24","height":"20","width":"20","stroke":"currentColor","stroke-width":"1.71"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.8 12.302c0 .08.027.16.076.223l1.062 1.338a1.528 1.528 0 01.131 1.72l-.624 1.076a1.528 1.528 0 01-1.552.748l-1.693-.255a.366.366 0 00-.23.043l-2.007 1.158a.363.363 0 00-.153.178l-.624 1.592a1.528 1.528 0 01-1.422.973H10.52a1.528 1.528 0 01-1.421-.971l-.625-1.592a.363.363 0 00-.152-.18l-2.005-1.158a.366.366 0 00-.23-.044l-1.693.257a1.528 1.528 0 01-1.554-.748l-.621-1.078a1.528 1.528 0 01.127-1.72l1.067-1.337a.355.355 0 00.08-.223V9.988a.36.36 0 00-.08-.223L2.345 8.427a1.528 1.528 0 01-.127-1.72l.62-1.076a1.528 1.528 0 011.555-.748l1.687.255a.366.366 0 00.231-.043l2.01-1.162a.365.365 0 00.152-.18l.628-1.586a1.528 1.528 0 011.423-.973h1.248a1.528 1.528 0 011.422.971l.624 1.588a.357.357 0 00.153.184l2.006 1.158a.366.366 0 00.231.044l1.69-.257a1.528 1.528 0 011.555.748l.622 1.078a1.528 1.528 0 01-.129 1.72L18.88 9.764a.355.355 0 00-.078.223v2.314z","fill":"none"}}),_c('path',{attrs:{"d":"M11.145 14.323c2.033 0 3.178-1.145 3.178-3.178s-1.145-3.178-3.178-3.178-3.178 1.145-3.178 3.178 1.145 3.178 3.178 3.178z","fill":"none"}})])
          )
        }
      }
    